import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { DemandReductionStation } from 'src/app/services/demand-reduction-data.service';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { DemandOverrideService, DemandReductionAdjustment } from '../../../../services/demand-override.service';
import { DateSelectService } from '../../../../services/date-select.service';

@Component({
  selector: 'app-demand-adjustment-button',
  templateUrl: './demand-adjustment-button.component.html',
  styleUrls: ['./demand-adjustment-button.component.scss'],
  providers: [NgbModalConfig, NgbModal]
})
export class DemandAdjustmentButtonComponent implements OnInit {

  private _demandOverrideData: DemandReductionAdjustment = {
    DemandEntityId: null,
    DemandValue: null,
    DemandDate: null,
    Notes: null
  };

  @Input() station: DemandReductionStation;

  ngOnChanges(changes: SimpleChanges) {
    this._demandOverrideData.DemandEntityId = this.station.demandEntityId;
    this._demandOverrideData.DemandValue = this.station.adjustedDemand;
    this._demandOverrideData.Notes = this.station.notes;
  }

 
  // @Input()
  // set demandOverrideData(demandOverrideData: object) {
  //   this._demandOverrideData.DemandEntityId = this.station.demandEntityId;
  //   this._demandOverrideData.DemandValue = this.station.adjustedDemand;
  //   this._demandOverrideData.Notes = this.station.notes;
  //   console.log('updating dOD');
  // }
 
  constructor(private modalConfig: NgbModalConfig, private modalService: NgbModal, private demandOverrideService: DemandOverrideService, private dateSelectObject: DateSelectService) {
    modalConfig.backdrop = 'static';
  }

  ngOnInit() {
    this.dateSelectObject.currentDate.subscribe((result) => {
      this._demandOverrideData.DemandDate = result;
    });
  }

  onSubmit() {
    this.demandOverrideService.postDemandOverride(this._demandOverrideData);
    this.modalService.dismissAll();
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-demand-adjustment'});
  }

}